import React, { useEffect } from 'react';
import moment from "moment-timezone";
import { MenuItem, Typography, Box, Button, Select, FormControl, Chip, TextField  } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import MaterialReactTable from 'material-react-table';
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import RefreshIcon from '@mui/icons-material/Refresh';
import DownloadIcon from '@mui/icons-material/Download';
import borders from "assets/mavric-theme/base/borders";
import { downloadProbeActivitiesReport, getCustomerProbeActivities, getCustomers, getDataconsumptionReportTypes } from 'apis/CustomersApis';
const { primary, secondary, text, tableRow, transparent } = colors;
const { size } = typography;
const { borderRadius } = borders;


const ProbeActivity = () => {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const [probeData, setProbeData] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [custDataList, setCustDataList] = React.useState([]);
    const [selectedCustomer, setSelectedCustomer] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [displayedView, setDisplayedView] = React.useState('thismonth');
    const [reportTypes, setReportTypes] = React.useState([]);
    const [currentView, setCurrentView] = React.useState('thismonth');
    const [downloading, setDownloading] = React.useState(false);
    const [timezone] = React.useState(userTimeZone);
    const columns = React.useMemo(() => [
        {
            accessorKey: 'customer_id',
            header: 'Customer ID',
            size: 150,
            Cell: ({ cell }) => {
                const value = cell.getValue();
                return value || '-';
            },
            enableColumnFilter: false
        },
        {
            accessorKey: 'org_name',
            header: 'Customer Name',
            size: 200,
            Cell: ({ cell }) => {
                const value = cell.getValue();
                return value || '-';
            },
            enableColumnFilter: false
        },
        {
            accessorKey: 'probe_serial_number',
            header: 'Probe Serial Number',
            size: 200,
            Cell: ({ cell }) => {
                const value = cell.getValue();
                return value || '-';
            },
            enableColumnFilter: false
        },
        {
            accessorKey: 'request_count',
            header: 'Request Count',
            size: 150,
            Cell: ({ cell }) => {
                const value = cell.getValue();
                return value || '-';
            },
            enableColumnFilter: false
        },
        {
            accessorKey: 'first_time',
            header: 'First Time',
            size: 200,
            Cell: ({ cell }) => {
                const value = cell.getValue();
                return value ? moment.utc(value).tz(userTimeZone).format("YYYY-MM-DD HH:mm:ss A") : '-';
            },
            enableColumnFilter: false
        },
        {
            accessorKey: 'last_time',
            header: 'Last Time',
            size: 200,
            Cell: ({ cell }) => {
                const value = cell.getValue();
                return value ? moment.utc(value).tz(userTimeZone).format("YYYY-MM-DD HH:mm:ss A") : '-';
            },
            enableColumnFilter: false
        }
        
    ], []);
    const [downloadDialog, dispatch] = React.useReducer((state, action) => {
        switch (action.type) {
            case "SET_FILENAME":
            return { ...state, filename: action.payload };
            case "SET_OPEN":
            return { ...state, open: action.payload };
            case "SET_BLOB":
            return { ...state, blob: action.payload };
            case "RESET":
            return { filename: "default", open: false, blob: null };
            default:
            return state;
        }
    }, { filename: "default", open: false, blob: null });

    useEffect(() => {
        // if (custDataList.length > 0) {
        //     const defaultCustomer = custDataList[0];
        //     setSelectedCustomer(defaultCustomer);
        //     fetchProbesActivity(currentView, defaultCustomer.customer_id);
        // }
        setSelectedCustomer(null);
        setProbeData([]);
    }, [custDataList]);

    const fetchProbesActivity = async (view, customerId) => {
        const selectedPeriod = view || currentView;
        setIsLoading(true);
        // BJ
        // const periodMap = { 'thismonth': 'thismonth', 'lastmonth': 'lastmonth', 'all': 'all' };
        // const periodStock = periodMap[currentView];

        try {
            const periodMap = {
            thismonth: "thismonth",
            lastmonth: "lastmonth",
            all: "all",
            };

            const duration = periodMap[selectedPeriod] || "thismonth";

            const params = {
            query_timezone: timezone,
            duration,
            };
            const response = await getCustomerProbeActivities(params, customerId);
            if (!response || !Array.isArray(response)) {
                console.warn("Invalid response format:", response);
                setProbeData([]);
                setDisplayedView(view);
                return;
            }
            setProbeData(response);
            setDisplayedView(view);
        } catch (error) {
            console.error('Error fetching probe activities:', error);
            setProbeData([]);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchReportTypesData = async () => {
        setLoading(true);
        try {
          const response = await getDataconsumptionReportTypes();
          // console.log("Data loaded:", response);
          const types = response && response.report_types
          const formattedTypes = types.map(type => ({
            value: type,
            label: type === 'thismonth' ? 'This Month' :
            type === 'lastmonth' ? 'Last Month' :
            type === 'all' ? 'All' : type
          }));
          setReportTypes(types);
    
        } catch (error) {
          console.error('Error:', error);
          setReportTypes([]);
        } finally {
          setLoading(false);
        }
    };

    const handleSelectionChange = (event) => { const selectedValue = event.target.value; setCurrentView(selectedValue); };

    const getViewLabelWithMonth = (view) => {
        const date = new Date();
        if (view === 'thismonth') {
        const monthName = date.toLocaleString('default', { month: 'long', year: 'numeric' });
        return monthName;
        } else if (view === 'lastmonth') {
        date.setMonth(date.getMonth() - 1);
        const monthName = date.toLocaleString('default', { month: 'long', year: 'numeric' });
        return monthName;
        } else if (view === 'all') {
        return 'All';
        }
        return 'Select Period';
    };

    const getCustomerData = () => {
        return new Promise(function (resolve, reject) {
            getCustomers().then((response) => { setCustDataList(response); resolve(response); })
            .catch((error) => {
                setCustDataList([]);
                let errMessage = '';
                if (error.response) {
                    errMessage = error.response.data.message;
                    if (error.response.status === 401 || error.response.status === 403) {
                        let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
                        dispatch(logout(jsonPostMsg));
                        history.push('/login');
                    }
                } else if (error.request) {
                    errMessage = `${error}`;
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                    errMessage = error.message;
                }
                reject(errMessage);
            });
        });
    };

    const getDisplayLabel = (value) => {
        const labels = { 'thismonth': 'This Month', 'lastmonth': 'Last Month', 'all': 'All' };
        return labels[value] || value;
    };

    const getUserActivitiesFileName = (period) => {
        const date = new Date();
        const year = date.getFullYear();
        if (period === 'all') {
        return `MX_ProbeActivities_Report_${year}.xlsx`
        } else {
        if (period === 'lastmonth') date.setMonth(date.getMonth() - 1);
        const monthName = date.toLocaleString('default', { month: 'short' });
        const monthYear = date.getFullYear();
        return `MX_ProbeActivities_Report_${monthName}_${monthYear}.xlsx`;
        }
    };

    const handleConfirmDownload = () => {
        if (downloadDialog.blob && downloadDialog.filename) {
            const url = window.URL.createObjectURL(downloadDialog.blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = downloadDialog.filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
        dispatch({ type: "RESET" });
    };

    const downloadReport = async () => {
        if (!currentView || !selectedCustomer) return;
        setDownloading(true);
        try {
            const periodMap = {
            'thismonth': 'thismonth',
            'lastmonth': 'lastmonth',
            'all': 'all'
            };
            const payload = {
                query_timezone: timezone,
                period: periodMap[displayedView],
                };
            // console.log('Download response:~bj', response);
            const period = periodMap[displayedView];
            const blob = await downloadProbeActivitiesReport(payload, selectedCustomer.customer_id);
            const filename = getUserActivitiesFileName(period);
            // console.log('Download filename:~bj', filename);
            dispatch({ type: "SET_BLOB", payload: blob });
            dispatch({ type: "SET_FILENAME", payload: filename });
            dispatch({ type: "SET_OPEN", payload: true });

        } catch (error) {
            console.error('Download error:', error);
        } finally {
            setDownloading(false);
        }
    };

    const handleFilenameChange = React.useCallback((e) => dispatch({ type: "SET_FILENAME", payload: e.target.value }), []);

    const handleCloseDialog = React.useCallback(() => dispatch({ type: "SET_OPEN", payload: false }), []);

    useEffect(() => {
        getCustomerData();
        fetchReportTypesData();
    }, []);

    const handleCustomerChange = async (e) => {
        const selectedOrgName = e.target.value;
        if(!selectedOrgName) {
        // User selected "Select Customer"
        setSelectedCustomer(null);         // Clear selected customer
        setProbeData([]);
        return;
        }
        const selectedCustomer = custDataList.find(customer => customer.org_name === selectedOrgName);
        if (selectedCustomer) {
        setSelectedCustomer(selectedCustomer);
        await fetchProbesActivity(currentView, selectedCustomer.customer_id);
        } else {
            setSelectedCustomer(null);
            setProbeData([]);
            console.log("Invalid customerId : ", selectedCustomer.customer_id);
        }
    };

    return (
        <>
            <Box sx={{ width: "50%", marginLeft: 2, marginBottom: 2, display: "flex", alignItems: "center", gap: 2 }}>
                <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 600, marginTop: '4px', marginBottom: '6px', whiteSpace: "nowrap" }}> Search Customer Name : </Typography>
                <Select 
                    id="customerId" 
                    name="customerId" 
                    value={selectedCustomer != null ? selectedCustomer.org_name : ""} 
                    onChange={handleCustomerChange} 
                    displayEmpty 
                    fullWidth sx={{ '.MuiSelect-select': { paddingTop: '8px !important', paddingBottom: '8px !important', minHeight: '35px !important', display: 'flex', alignItems: 'center', fontSize: '1em !important' }}} 
                    > 
                    {/* Default Option */}
                    <MenuItem value="">
                        <em>Select Customer</em>
                    </MenuItem>
    
                    {custDataList && custDataList.length > 0 &&
                    custDataList.map((customer) => (
                        <MenuItem
                        key={customer.customer_id}
                        value={customer.org_name}
                        >
                        {customer.org_name}
                        </MenuItem>
                    ))
                    } 
                </Select>
            </Box>
            <Box sx={{ mt: 3, '& .MuiPaper-root': { borderRadius: 3, overflow: 'hidden' } }}>
                <MaterialReactTable
                    key={`probe-activity`}
                    columns={columns}
                    data={probeData}
                    state={{ isLoading }}
                    muiTableToolbarAlertBannerProps={{ sx: { display: 'none' } }}
                    muiTablePaperProps={{ sx: { boxShadow: 'none', backgroundColor: primary.main, p: 2 } }}
                    muiTableBodyRowProps={({ row }) => ({ hover: true,sx: { color: text.main, align: 'center', '&:nth-of-type(odd)': { backgroundColor: tableRow.dark, border: 0 }, '&:nth-of-type(even)': { background: tableRow.light }, '&:last-child td, &:last-child th': { border: 0 }, '&:hover td': { background: tableRow.hover }, '& td': { lineHeight: 2.1 } },})}
                    muiTableBodyCellProps={{ sx: { border: 'none', color: text.main, align: 'center', boxShadow: 'none', padding: '4px 8px', } }}
                    muiTableProps={{ sx: { backgroundColor: primary.main, color: text.main, boxShadow: 'none' } }}
                    muiTopToolbarProps={{ sx: { backgroundColor: primary.main, boxShadow: 'none', minHeight: 0 } }}
                    muiBottomToolbarProps={{ sx: { backgroundColor: primary.main, boxShadow: 'none' } }}
                    muiTableHeadRowProps={{ sx: { backgroundColor: primary.main, color: text.main, textAlign: 'center' }, }}
                    muiTableHeadCellProps={{ sx: { borderBottom: 0, verticalAlign: 'none', boxShadow: 'none', align: 'center', color: text.main } }}
                    enableColumnActions={false}
                    enableColumnOrdering={false}
                    enablePinning={false}
                    enableSelectAll={false}
                    enableStickyHeader={false}
                    enableClickToCopy={false}
                    positionPagination="bottom"
                    enableToolbarInternalActions={false}
                    enablePagination={true}
                    initialState={{ density: 'compact', showColumnFilters: true, boxShadow: 'none', pagination: { pageSize: 10, pageIndex: 0, pageCount: -1 }, sorting: [ { id: 'customer_id', desc: false, } ], }}
                    positionActionsColumn="last"
                    muiTablePaginationProps={{ rowsPerPageOptions: [3, 5, 10, 15, 20], sx: { color: text.main, '& p': { marginBottom: 0 }, '& .MuiSvgIcon-root': { color: text.main, }, } }}
                    muiTableContainerProps={{ sx: { padding: '0 !important', } }}
                    enableSorting={true}

                    renderTopToolbar={({ table }) => (
                        <Box sx={{ display: 'flex', gap: 2, p: 0.5, pl: 0, pr: 0, justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gap: 2, }}>
                        <FormControl size="medium" sx={{ minWidth: 150 }}>
                            <Select value={currentView} onChange={handleSelectionChange} sx={{ '& .MuiSelect-select': { paddingTop: '8px !important', paddingBottom: '8px !important', minHeight: '30px !important', display: 'flex', alignItems: 'center', py: 1, fontSize: '0.875rem !important' }, '& .MuiSvgIcon-root': { width: 22, height: 22, top: 10 } }} >{reportTypes.map((item, index) => (  <MenuItem key={`timePeriods${index}`} value={item}> {getDisplayLabel(item)} </MenuItem> ))}</Select>
                        </FormControl>
                        <Button
                            onClick={() => selectedCustomer && fetchProbesActivity(currentView, selectedCustomer.customer_id)}
                            variant="contained"
                            sx={{ '&:hover': { backgroundColor: secondary.main } }}
                            color="secondary"
                            size="medium"
                            startIcon={<RefreshIcon />}
                            disabled={!selectedCustomer || isLoading}
                        >
                            {isLoading ? 'fetching...' : 'Fetch Data'}
                        </Button>

                        <Button
                            onClick={downloadReport}
                            variant="contained"
                            color="secondary"
                            size="medium"
                            startIcon={<DownloadIcon />}
                            disabled={!selectedCustomer || downloading}
                        >
                            {downloading ? 'Downloading...' : 'Download Report'}
                        </Button>
                        </Box>
                        <Box sx={{ display: 'flex' }}>  <Chip label={getViewLabelWithMonth(displayedView)} color="secondary" variant="outlined" size="medium" sx={{'& .MuiChip-label': { fontSize: '1rem', fontWeight: 600 } }} /> </Box>
                        </Box>
                    )}
                />
            </Box>

            <Dialog open={downloadDialog.open} onClose={handleCloseDialog} maxWidth="sm" aria-labelledby="scroll-dialog-title" aria-describedby="scroll-dialog-description" sx={{ '& .MuiDialog-paper': { backgroundColor: primary.main, } }} fullWidth >
            <DialogTitle id="alert-dialog-title"> <Typography fontSize={size.lg} color={secondary.main} sx={{ fontWeight: 600, }}>{'Confirm Download'}</Typography> </DialogTitle>
            <DialogContent>
                <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Filename</Typography>
                <TextField type="text" fullWidth focused={false} value={downloadDialog.filename} onChange={handleFilenameChange} sx={{ color: text.main, backgroundColor: transparent.main, borderRadius: borderRadius.md, }} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog} variant="contained" color="secondary"> Cancel </Button>
                <Button onClick={handleConfirmDownload} color="secondary" variant="contained" disabled={!downloadDialog.filename.trim()}> Download </Button>
            </DialogActions>
            </Dialog>
        </>
    )
}

export default ProbeActivity
